/* @flow */

import * as React from 'react';
import { FormattedNumber } from 'react-intl';

const FAVORABLE_WHITE_GLOVE_PRICE = 150;

export function isPriceAboveThreshold({
    convertedAmountList,
    threshold = FAVORABLE_WHITE_GLOVE_PRICE,
}: {
    convertedAmountList: Array<Object>,
    threshold?: number,
}) {
    if (!convertedAmountList) {
        return false;
    }
    const result = convertedAmountList.find(p => p.currency === 'USD');
    return !!result && result.amount > threshold;
}

type ShippingPriceType = {
    convertedAmountList: Array<Object>,
    currency: string,
};

export function getShippingPrice({ convertedAmountList, currency }: ShippingPriceType) {
    if (!convertedAmountList) {
        return null;
    }
    const { amount } = convertedAmountList.find(p => p.currency === currency) || {};
    if (amount > 0) {
        return (
            <FormattedNumber
                value={amount}
                style="currency"
                currency={currency}
                minimumFractionDigits={0}
            />
        );
    }
    return null;
}
